import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu on link click
  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <header className="header">
      {/* --- LOGO & BRAND SECTION --- */}
      <div className="order">
        <NavLink to="/" end onClick={handleLinkClick}>
          <img className="logo" src="TechLoopsSolutions.webp" alt="Logo" />
        </NavLink>
        <div className="brand">TechLoops Solutions</div>
      </div>

      {/* --- MOBILE TOGGLE BUTTON (Hamburger/X) --- */}
      <button 
        className="menu-toggle" 
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label={menuOpen ? "Close menu" : "Open menu"}
      >
        {menuOpen ? '✕' : '☰'} 
      </button>

      {/* --- NAVIGATION LINKS --- */}
      <nav className={menuOpen ? 'open' : ''}>
        <NavLink to="/" end onClick={handleLinkClick}>Home</NavLink>
        <NavLink to="/what-we-do" onClick={handleLinkClick}>What We Do</NavLink>
        <NavLink to="/who-we-are" onClick={handleLinkClick}>Who We Are</NavLink>
        <NavLink to="/insights" onClick={handleLinkClick}>Insights</NavLink>
        <NavLink to="/careers" onClick={handleLinkClick}>Careers</NavLink>
        <NavLink to="/contact" onClick={handleLinkClick}>Contact Us</NavLink>
      </nav>
    </header>
  );
}